import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

@Component({
    mixins: [ProjectMixin],
    inheritAttrs: false,
})
export default class AutocompleteProject extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop() value!: any
    @Prop({ default: () => [] }) initItems!: any

    searchTerm = ''
    projects: any = this.initItems
    loading = false

    name(project) {
        return project.attributes ? project.attributes.name : ''
    }

    @Watch('searchTerm')
    async search() {
        this.loading = true
        let params = {
            ...(this.searchTerm?.trim().length > 1 && { 'filter[searchTerm]': this.searchTerm }),
            'page[offset]': 0,
            'page[limit]': 20,
        }

        this.projects = await this.searchProjects(params).catch(() => {
            this.loading = false
        })

        this.loading = false
    }

    passValue(data: any) {
        this.$emit('passValue', data)
    }
}
